import { ComponentProps } from "react";
import { BlockTitle } from "@blocks/Blocks";
import Ad from "@components/Advertisement/Ad";
import { getWealthRealEstateVariant } from "@pages/Section/layouts/Wealth/components/RealEstate/utils/helpers";
import Card from "@particles/card/Card";
import { cn } from "@util/helpers";

type WealthRealEstateProps = {
  /** Optional className for the component */
  className?: string;
  /** The card props for the wealth real estate component */
  cardProps: ComponentProps<typeof Card>[];
};

/**
 * Wealth Real Estate component that will be displayed on the Wealth page
 * LEGACY COMPONENT NO FIGMA LINK
 */
const WealthRealEstate = ({
  className,
  cardProps,
}: WealthRealEstateProps): React.ReactElement => {
  return (
    <div data-testid="wealth-real-estate-component" className={className}>
      <BlockTitle
        text="REAL ESTATE"
        link="/property"
        rootClassName="mb-3 border-t border-black pt-3"
      />

      <div className="grid gap-6 lg:grid-cols-3">
        <div className="stories col-span-1 grid grid-cols-1 gap-x-6 md:grid-cols-2 md:grid-rows-3 lg:col-span-2 ">
          {cardProps.map((cardProp, index) => {
            const variant = getWealthRealEstateVariant(index);

            return (
              <Card
                key={cardProp.id}
                {...cardProp}
                variations={variant}
                className={cn(
                  "relative md:flex-col",
                  "after:absolute after:bottom-0 after:left-0 after:right-0 after:h-[1px] after:bg-gray-175",
                  {
                    "row-span-1 flex-nowrap bg-gray-150 md:row-span-3 md:after:hidden":
                      index === 0,
                    "after:hidden": index === 3,
                  }
                )}
              />
            );
          })}
        </div>

        <div className="col-span-1">
          <Ad
            adType="imu2"
            className="flex flex-col items-center justify-center lg:sticky lg:top-[70px]"
          />
        </div>
      </div>
    </div>
  );
};

export default WealthRealEstate;
